module.exports = __webpack_public_path__ + "static/media/Catalyst.3b6db441.png";